import { ControlledInput } from '@/components/controlled';
import { useFormContext } from 'react-hook-form';
import { Label } from '@/components/ui';
import { TProps } from '..';

const FormContentCreateOrEditCreatorPaymentMethodMobileMoney = ({ fieldNames, readonly = false }: TProps) => {

  const { control } = useFormContext();

  return (
    <div className='space-y-4'>
      <div className='flex flex-col gap-2'>
        <Label>
          Téléphone
        </Label>
        <ControlledInput
          maxLength={13}
          disabled={readonly}
          control={control}
          name={fieldNames.paymentInfo.phoneNumber}
          placeholder={'Numéro de téléphone'} />
      </div>
      <div className='flex flex-col gap-2'>
        <Label>
          Nom du propriétaire
        </Label>
        <ControlledInput
          maxLength={50}
          disabled={readonly}
          control={control}
          name={fieldNames.paymentInfo.phoneNumberOwnerName}
          placeholder={'Nom du propriétaire'} />
      </div>
    </div>
  );

};

export default FormContentCreateOrEditCreatorPaymentMethodMobileMoney;
